import VolunteerAvailabilityPreference from "./volunteer-availability-preference";
import VolunteerLocationPreference from "./volunteer-location-preference";

export default class VolunteerSchedule {
  availabilities: VolunteerAvailabilityPreference[];
  locationPreferences: VolunteerLocationPreference[];

  constructor(
    availabilities: VolunteerAvailabilityPreference[] = [],
    locationPreferences: VolunteerLocationPreference[] = []
  ) {
    this.availabilities = availabilities;
    this.locationPreferences = locationPreferences;
  }

  public findAvailability(day: string): VolunteerAvailabilityPreference {
    if (!this.locationPreferences) {
      return {
        day: day.toUpperCase(),
        selected: false,
        morning: false,
        afternoon: false,
        evening: false,
      };
    }

    const a = this.availabilities.find((x) => {
      return x.day.toLocaleLowerCase() === day.toLocaleLowerCase();
    });

    return !a
      ? {
          day: "MONDAY",
          selected: false,
          morning: false,
          afternoon: false,
          evening: false,
        }
      : a;
  }
}



// WEBPACK FOOTER //
// ./src/models/resource-management/volunteers/volunteer-schedule.ts